import injected from "./injected";
import walletconnect from "./walletconnect";
import portis from "./portis";
import fortmatic from "./fortmatic";
import torus from "./torus";
import arkane from "./arkane";
import authereum from "./authereum";
import burnerconnect from "./burnerconnect";
import mewconnect from "./mewconnect";
import dcentwallet from "./dcentwallet";
import bitski from "./bitski";
import frame from "./frame";
import binancechainwallet from "./binancechainwallet";

export {
  injected,
  walletconnect,
  portis,
  torus,
  fortmatic,
  arkane,
  authereum,
  burnerconnect,
  mewconnect,
  dcentwallet,
  bitski,
  frame,
  binancechainwallet
};
